import { useQuery } from "@tanstack/react-query";
import { notificationKeys } from "../notification.keys";
import { notificationApi } from "../service";

/**
 * The VAPID public key, fetched rather than baked in at build time.
 *
 * It has to be in hand *before* `subscribe()` is called, so this is loaded eagerly wherever a
 * subscribe might happen. `staleTime: Infinity` because the key changes only on a deployment
 * that invalidates every subscription anyway, and `retry: false` because a 503 here means push
 * is switched off on this deployment — retrying will not turn it on.
 */
export function useVapidPublicKey(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: notificationKeys.vapidKey(),
    queryFn: () => notificationApi.getVapidPublicKey().then((response) => response.data),
    staleTime: Infinity,
    retry: false,
    enabled: options?.enabled ?? true,
  });
}
